import { Id_floor, Id_building, Id_category, Id_drawing } from './api/Identifiers'


function get_query_string_parameter(key: string, default_val: string) {
    let url: any = window.location.href;
    key = key.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + key + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) {
        if (default_val === undefined) {
            default_val = null;
            console.error("fetching paramter '" + key + " ' failed with no default value to fall back on.")
        }
        return default_val;
    }
    if (!results[2]) {
        return '';
    }
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}


function get_str_or_null(key: string): string | null {
    let r: string = get_query_string_parameter(key, null);
    if (r === null) {
        r = null
    }
    if (typeof (r) !== typeof ("")) {
        r = null
    }
    return r;
}


function get_boolean(key: string, default_value: boolean): boolean {
    let val: string = get_str_or_null(key)

    if (typeof val === 'undefined') {
        return default_value;
    }

    if (val === null) {
        return default_value
    }

    if (typeof val === 'string') {
        if (val.toLowerCase() === "true") {
            return true
        }
        if (val.toLowerCase() === "1") {
            return true
        }
    }
    return false
}

function get_num_or_null(key: string): number {
    let num: number = parseInt(get_str_or_null(key));
    if (isNaN(num)) {
        return null
    }
    return num;
}

export class QueryString {

    
    // REQUIRED
    public static readonly  KEY_O_FILTER_FINDING_ID_CATEGORY: string = "filter_finding_id_category"; // OPTIONAL
    public static readonly  KEY_O_FLOORPLAN_API_GATEWAY: string = "floorplan_api_gateway";           // OPTIONAL
    public static readonly  KEY_O_ID_BUILDING: string = "building_id_location";                      // OPTIONAL
    public static readonly  KEY_O_ID_DRAWING: string = "id_drawing";                                 // OPTIONAL
    public static readonly  KEY_O_ID_FLOOR: string = "id_floor";                                     // OPTIONAL
    public static readonly  KEY_O_READ_ONLY: string = "read_only";                                   // OPTIONAL
    public static readonly  KEY_O_USE_NGROK: string = "use_ngrok";                                   // OPTIONAL
    public static readonly  KEY_O_WORKORDER_QUERY: string = "workorderquery";                        // OPTIONAL
    public static readonly  KEY_R_API_GATEWAY: string = "api_gateway";

	public static readonly  KEY_O_STORAGE_ACCOUNT_URL: string = "storage_account_url";

    public static readonly  KEY_R_API_TOKEN: string = "token";
    public static readonly  KEY_R_CUSTOMER_NAME: string = "customername";
    public static readonly  KEY_R_DEEP_LOGGING: string = "deep_logging";
    public static readonly  KEY_R_ID_CUSTOMER: string = "customerid";
    public static readonly  KEY_R_ID_SEGMENT: string = "segmentid";
    public static readonly  KEY_R_PARENT_APP: string = "parent_app";


    public constructor() { }
    public static readonly VALUE_CMS_TECH: string = "cms_tech"
    public static readonly VALUE_CMS_ROUNDING: string = "cms_rounding"
    public static readonly VALUE_CMS_SURVEYOR: string = "cms_surveyor"

    public static get id_floor(): Id_floor | null {
        let r: string = get_str_or_null(QueryString.KEY_O_ID_FLOOR);
        if (r === null) {
            return null
        }
        return Id_floor.wrap(r);
    }

    public static get id_drawing(): Id_drawing | null {
        let r: string = get_str_or_null(QueryString.KEY_O_ID_DRAWING);
        if (r === null) {
            return null
        }
        return Id_drawing.wrap(r);
    }

    public static get api_token(): string {
        let r: string = get_str_or_null(QueryString.KEY_R_API_TOKEN);
        if (r === null) {
            return null
        }
        return r;
    }

    public static get api_gateway(): string {
        let r: string = get_str_or_null(QueryString.KEY_R_API_GATEWAY);
        if (r === null) {
            return null
        }
        return r;
    }

	public static get storage_account_url(): string {
        let r: string = get_str_or_null(QueryString.KEY_O_STORAGE_ACCOUNT_URL);
        if (r === null) {
            return null
        }
        return r;
    }


    public static get id_segment(): number {
        let r: number = get_num_or_null(QueryString.KEY_R_ID_SEGMENT);
        if (r === null) {
            return null
        }
        return r;
    }

    public static get customer_name(): string {  // sometimes called the 'site_code'
        let r: string = get_str_or_null(QueryString.KEY_R_CUSTOMER_NAME);
        if (r === null) {
            return null
        }
        return r.toLowerCase();
    }

    public static get id_customer(): number {
        let r: number = get_num_or_null(QueryString.KEY_R_ID_CUSTOMER);
        if (r === null) {
            return null
        }
        return r;
    }

    public static get is_read_only(): boolean {
        return get_boolean(QueryString.KEY_O_READ_ONLY, false);
    }

    public static get use_ngrok(): boolean {
        return get_boolean(QueryString.KEY_O_USE_NGROK, false);
    }

    public static get is_deep_logging(): boolean {
        return get_boolean(QueryString.KEY_R_DEEP_LOGGING, false);
    }

    public static get id_building(): Id_building | null {
        let r: string = get_str_or_null(QueryString.KEY_O_ID_BUILDING);
        if (r === null) {
            return null
        }
        return Id_building.wrap(r);
    }

    public static get parent_app(): string | null {
        let r: string = get_str_or_null(QueryString.KEY_R_PARENT_APP);
        if (r === null) {
            return null
        }
        return r;
    }
    
    public static get workorder_query(): any | null {
        let workorder_query_string: string = get_str_or_null(QueryString.KEY_O_WORKORDER_QUERY);
        if (workorder_query_string === null) {
            return null
        }
        let workorder_query_obj: any = JSON.parse(workorder_query_string)
        return workorder_query_obj;
    }

    public static get filter_finding_id_category(): Id_category | null {
        let r: string = get_str_or_null(QueryString.KEY_O_FILTER_FINDING_ID_CATEGORY);
        if (r === null) {
            return null
        }
        return Id_category.wrap(r);
    }


    public static get floorplan_api_gateway(): string | null {
        let r: string = get_str_or_null(QueryString.KEY_O_FLOORPLAN_API_GATEWAY);
        if (r === null) {
            return null
        }
        return <string>r;
    }
}




// WEBPACK FOOTER //
// ./src/ts/QueryString.ts